// How long since we last touched a file that we still trust it exists on the server
export const fileTouchTimeout = 1000 * 60 * 10
export const taskTouchTimeout = 1000 * 60 * 10
export const lockPrefixes = {
  fileTouch: 'TOUCH_',
  fileDownload: 'DOWNLOAD_',
  sampleCollectionProcessing: 'SAMPLE_COLLECTION_PROCESSING'
}